import styled from "styled-components";
import Button from "@mui/material/Button";

const isDarkMode = (theme: any) => theme.palette.mode === "dark";

export const Wrapper = styled.section`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding-top: ${({ theme }) => theme.coefficient * 28}px;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: min(760px, 100%);
  padding: ${({ theme }) => theme.coefficient * 36}px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background:
    radial-gradient(circle at top right, rgba(15, 195, 255, 0.16) 0%, transparent 34%),
    linear-gradient(180deg, #0d234f 0%, #0a1b40 100%);
  box-shadow: 0 28px 80px rgba(7, 18, 43, 0.42);
  overflow: hidden;
`;

export const Eyebrow = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.6rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.value_20};
  margin-bottom: ${({ theme }) => theme.coefficient * 12}px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 3.6rem;
  line-height: 4rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.value_01};
`;

export const Description = styled.p`
  margin: ${({ theme }) => theme.coefficient * 18}px 0 0 0;
  font-size: 1.7rem;
  line-height: 2.6rem;
  color: ${({ theme }) => (isDarkMode(theme) ? theme.colors.value_29 : theme.colors.value_31)};
`;

export const Actions = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.coefficient * 28}px;
`;

export const BackButton = styled(Button)(({ theme }) => ({
  height: `${theme.coefficient * 40}px`,
  padding: `0 ${theme.coefficient * 20}px`,
  backgroundColor: `${theme.colors.value_20} !important`,
  color: `${theme.colors.value_01} !important`,
  textTransform: "none",
  fontSize: "1.4rem !important",
  fontWeight: "600 !important",
}));
